(function () {
  function initCartDiscount(root) {
    const discountRoot = root || document.querySelector('[data-cart-discount]');
    if (!discountRoot || discountRoot.dataset.initialized === 'true') return;

    const trigger = discountRoot.querySelector('.cart-discount__trigger');
    const panel = discountRoot.querySelector('.cart-discount__panel');
    const input = discountRoot.querySelector('input[name="custom-discount-input"]');

    if (!trigger || !panel) return;

    discountRoot.dataset.initialized = 'true';

    function setOpen(isOpen) {
      discountRoot.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.hidden = !isOpen;

      if (isOpen && input) {
        window.requestAnimationFrame(() => input.focus());
      }
    }

    function shouldStartOpen() {
      const hasAppliedDiscounts = discountRoot.querySelector('.cart_discounts .custom_discount_name_div') !== null;
      const hasMessage = discountRoot.querySelector('.coupon-message')?.textContent?.trim();
      const hasInputValue = input?.value?.trim();
      const hasVisibleError = discountRoot.querySelector('.custom-discount-form .error')?.style.display === 'block';

      // Applied codes are listed outside the panel, so they no longer open it:
      // the input stays closed by default (Abi, 2026-10-30).
      return hasMessage || hasInputValue || hasVisibleError;
    }

    trigger.addEventListener('click', () => {
      setOpen(!discountRoot.classList.contains('is-open'));
    });

    if (shouldStartOpen()) {
      setOpen(true);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cart-discount]').forEach(initCartDiscount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', initAll);
  document.addEventListener('dispatch:cart-drawer:refresh', initAll);

  window.initCartDiscountPanels = initAll;
})();
